var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "\n<div class=\"payment-grid\"></div>\n\n<p class=\"total\">"
    + container.escapeExpression(((helper = (helper = helpers.totalLabel || (depth0 != null ? depth0.totalLabel : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"totalLabel","hash":{},"data":data}) : helper)))
    + " $<span class=\"amount\">0.00</span></p>";
},"useData":true});